import ScrollOut from "scroll-out";
import $ from 'jquery';
import JSConfetti from 'js-confetti';
$(document).ready(() => {
    ScrollOut({
        targets: '.scroll-out',
        threshold: .2,
        onShown(el) {
          $(el).addClass('animated');
        }
      });

      ScrollOut({
        targets: 'body',
        offset: 30,
        onShown(el) {
          $('body').addClass('scrolled');
        },
        onHidden() {
          $('body').removeClass('scrolled');
        }
      });
});


let videoPlayed = false;
document.addEventListener('DOMContentLoaded', () => {
  function intersect(items) {
    items.forEach((item) => {
      if(item.isIntersecting) {
        if(item.target.classList.contains('onboarding-list')){
          setTimeout(() => {
            if (!videoPlayed) {
              document.querySelector('#onboarding-video video').play();    
              videoPlayed = true;
            }
          }, 2200)
        }
        item.target.classList.add('animated');
      }
    });
    }
  
    let options = {
    rootMargin: '-100px',
    threshold: .5
    }
  
    const observer = new IntersectionObserver(intersect, options);
    const sections = document.querySelectorAll('.animation');
  
    sections.forEach((item) => {
      observer.observe(item);
    });
});
